/** @format */

import React, { useState, useRef, useEffect } from "react";
import style from "./index.module.scss";
import cn from "classnames";
import { CURRENCIES } from "../../../mock";

const CustomInputCurrency = ({
  onChangeValue = () => void 0,
  onChangeCurrency = () => void 0,
  inputType = "number",
  isDisabled = false,
  isBgGray = false,
  value = "",
  currency = "kzt",
  paddingLeft = "",
  prefixStart = "",
  maxLength = "",
  placeholder = "",
  labelText = "",
  errorText = "",
  onKeyPress = () => {},
  lockCurrency = false,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const currencyButtonRef = useRef(null);

  const currentCurrency = CURRENCIES[currency] || CURRENCIES.KZT;

  const onFocus = () => setIsFocused(true);
  const onBlur = () => setIsFocused(false);

  const getValue = (event) => {
    let newValue = event.target.value;

    if (inputType === "number") {
      newValue = newValue ? Number(newValue) : "";
    }

    onChangeValue(newValue);
  };

  const handleCurrencySelect = (currencyCode) => {
    onChangeCurrency(currencyCode);
    setDropdownOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        currencyButtonRef.current &&
        !currencyButtonRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <div className={style.wrapper}>
        {prefixStart && <span className={style.prefixStart}>{prefixStart}</span>}
        <label
          className={cn(style.labelInp, {
            [style.focusedLabel]: isFocused,
            [style.labelError]: errorText,
          })}
        >
          {labelText}
        </label>
        <input
          type={inputType}
          className={cn(style.input, {
            [style.input_pdLeft40]: prefixStart,
            [style.input_pdRight]: true,
            [style.input_disabled]: isDisabled,
            [style.input_bg_wgray]: isBgGray,
            [style.input_errorState]: errorText,
          })}
          readOnly={isDisabled}
          disabled={isDisabled}
          value={value}
          placeholder={placeholder}
          onChange={getValue}
          maxLength={maxLength}
          onWheel={(event) => event.target.blur()}
          onFocus={onFocus}
          onBlur={onBlur}
          onKeyPress={onKeyPress}
        />

        <div
          ref={currencyButtonRef}
          className={style.currencySelector}
          style={lockCurrency ? { cursor: "default" } : undefined}
          onClick={() => !isDisabled && !lockCurrency && setDropdownOpen(!dropdownOpen)}
        >
          <span className={style.currencySymbol}>{currentCurrency.symbol}</span>
          {!lockCurrency && <span className={style.currencyArrow}>▼</span>}
        </div>

        {!lockCurrency && dropdownOpen && (
          <div ref={dropdownRef} className={style.currencyDropdown}>
            {Object.keys(CURRENCIES).map((code) => (
              <div
                key={code}
                className={cn(style.currencyOption, {
                  [style.currencyOptionSelected]: code === currency,
                })}
                onClick={() => handleCurrencySelect(code)}
              >
                <span className={style.currencySymbol}>{CURRENCIES[code].symbol}</span>
                <span className={style.currencyCode}>{code}</span>
              </div>
            ))}
          </div>
        )}
      </div>
      {errorText && <div className={style.errorText}>{errorText}</div>}
    </div>
  );
};

export default CustomInputCurrency;
